import {getBulkActionSlice} from 'src/components/bulk-tool';

import type {
    BulkActionIdSelector,
    BulkActionShownSelector,
    BulkActionTaskSelector,
} from 'src/components/bulk-tool';

export const subscribeToLcdCreditAnalysisSlice = getBulkActionSlice(
    'subscribeToLcdCreditAnalysis',
);

export const subscribeToLcdCreditAnalysisUuidSelector: BulkActionIdSelector = state =>
    state.bulkUpdateResult.subscribeToLcdCreditAnalysisResult.uuid;

export const subscribeToLcdCreditAnalysisShownSelector: BulkActionShownSelector = state =>
    state.bulkUpdateResult.subscribeToLcdCreditAnalysisResult.shown;

export const subscribeToLcdCreditAnalysisTaskSelector: BulkActionTaskSelector = state =>
    state.bulkUpdateResult.subscribeToLcdCreditAnalysisResult.backgroundTask;


export const {
    setUuid,
    setShown,
    setBackgroundTask,
    clearResult,
} = subscribeToLcdCreditAnalysisSlice.actions;
